'use strict';

var React = require('react');
var styleHelper = require('../../helper/styleHelper.js');
var Border = require('../common/Border');
var AutoSizeHelper = require('../common/AutoSizeHelper');
var convertHelper = require('../../types/convertHelper');
var Dom = require('react-dom');
var util = require('../../helper/util');
var _ = require('underscore');

var TextInput = React.createClass({

  _doPaint: function () {
    var com;
    var parentDom;
    var size;

    if (this.props.isAutoSize) {
      com = Dom.findDOMNode(this);
      parentDom = com.parentElement;

      while (!parentDom && (parentDom.id !== this.props.controlID)) {
        parentDom = parentDom.parentElement;
      }

      if (parentDom) {
        size = AutoSizeHelper.getComAutoSize(this.props);
        parentDom.style.width = size.width + 6 + 'px';
        parentDom.style.height = size.height + 8 + 'px';
      }
    }
  },


  componentDidMount: function () {
    this._doPaint();
    $(Dom.findDOMNode(this)).on('itemClick', this._onSelfClick);
  },

  render: function () {
    var h = styleHelper.getHeight(this.props);

    var inputStyle = {
      position: 'absolute',
      zIndex: 2,
      width: '100%',
      height: '100%',
      border: 'none',
      paddingLeft: 2,
      paddingRight: 2,
      margin: 0,
      boxSizing: 'border-box',
      outline: 'none',
      lineHeight: h - 2 + 'px'
    };
    styleHelper.StyleUtil(this.props, inputStyle).align().text().background().border();
    if(_.isUndefined(this.props.canInput) || this.props.canInput){
      return (
        <input
          ref="input"
          defaultValue={this.state.text}
          style={inputStyle}
          onBlur={this.onBlur}
        />
      );
    }else{
      return (
        <input
          ref="input"
          disabled
          defaultValue={this.state.text}
          style={inputStyle}/>
      );
    }

  },

  _onSelfClick: function () {
    this.startInput();
  },

  startInput: function () {
    this.props.events.doSelfClick(this.props, 'interactive-link', 0);
  },

  onBlur:function(){
    this.setState({text:Dom.findDOMNode(this).value})
  },

  componentDidUpdate : function(){
    if(this.props.currentText){
      Dom.findDOMNode(this).value = this.props.currentText
    }
  },

  componentWillReceiveProps : function(newProps){
    var text = styleHelper.getText(newProps);
    if(text !== this.state.text){
      text = util.Text.replaceIndentSpace(util.Text.convertSpaceToNbsp(text));
      this.setState({text:text});
    }
  },

  getInitialState: function () {
    return {
      text:  styleHelper.getText(this.props)
    }
  }

});

module.exports = TextInput;



/** WEBPACK FOOTER **
 ** ./src/views/Components/TextInput.jsx
 **/